var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.51615C2.00002 8.40335 2.33759 7.31674 2.96813 6.39982C3.59867 5.4829 4.49252 4.77881 5.53161 4.38055C6.5707 3.98229 7.70616 3.9086 8.78801 4.1692C9.86987 4.4298 10.8472 5.01243 11.591 5.84015C11.6434 5.89617 11.7067 5.94082 11.7771 5.97135C11.8474 6.00188 11.9233 6.01764 12 6.01764C12.0767 6.01764 12.1526 6.00188 12.2229 5.97135C12.2933 5.94082 12.3566 5.89617 12.409 5.84015C13.1504 5.00705 14.128 4.41952 15.2116 4.15575C16.2952 3.89199 17.4335 3.9645 18.4749 4.36364C19.5163 4.76277 20.4114 5.46961 21.0411 6.39006C21.6708 7.3105 22.0053 8.40091 22 9.51615C22 11.8062 20.5 13.5162 19 15.0162L13.508 20.3292C13.3217 20.5432 13.0919 20.7151 12.834 20.8335C12.5762 20.9518 12.296 21.014 12.0123 21.0158C11.7285 21.0176 11.4476 20.959 11.1883 20.8439C10.9289 20.7288 10.697 20.5598 10.508 20.3482L5 15.0162C3.5 13.5162 2 11.8162 2 9.51615Z",
    stroke: "#0A1D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/Family.a6601347f1fc0d427f6d8869eb0218f0.svg";
export { ForwardRef as ReactComponent };